import React from 'react';
import { Animated, View } from 'react-native';
import { useCardAnimation } from '@react-navigation/stack';

import { alertsModalPageTestIDs } from '@constants';

import { propertiesPage, selectAlert } from './helpers';
import { styles } from './style';

import { TWCPage } from '../../components/primitives/TWCPage/TWCPage';

export const AlertsModalPage = ({ navigation, route }) => {
  const { type, data } = route.params;
  const { current } = useCardAnimation();

  const onPageBlur = () => {
    // Check nav state, make sure we only prevent blur if this is the active page
    const navState = navigation.getState();

    if (navState.routes[navState.routes.length - 1].name === alertsModalPageTestIDs.alertsModalPage) {
      // Prevent the page from losing focus
      return true;
    }
  };

  return (
    <TWCPage
      {...propertiesPage(type)}
      hasBackground={false}
      pageID={alertsModalPageTestIDs.alertsModalPage}
      onPageBlur={onPageBlur}
    >
      <View style={styles.modalWrapper}>
        <Animated.View
          style={{
            transform: [
              {
                scale: current.progress.interpolate({
                  inputRange: [0, 1],
                  outputRange: [0.9, 1],
                  extrapolate: 'clamp',
                }),
              },
            ],
          }}
        >
          {selectAlert(type, navigation, data)}
        </Animated.View>
      </View>
    </TWCPage>
  );
};
